export const GET_LOGIN_TOKEN = 'app/getLoginToken';
export const GET_AUTH_CODES = 'app/getAuthCodes';
export const GET_LOGIN_USER = 'app/getLoginUser';
export const GET_LANGUAGE = 'app/getLanguage';
export const GET_COUNTRY = 'app/getCountry';
export const GET_DICTS = 'app/getDicts';

export const ACTION_TOKEN_LOGIN = 'app/tokenLogin';
